import Cookies from 'js-cookie';
export const systemTokenKey = 'Prome_Unitoken';
export const tokenUtil = {
  get: () => Cookies.get(systemTokenKey),
  set: (token: string) => Cookies.set(systemTokenKey, token),
  remove: () => Cookies.remove(systemTokenKey)
};
